package com.essntl.features.proposal.ui.allproposal.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.SmallFloatingActionButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.uikit.components.icons.EsMediumIcon
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.*

@Composable
fun ProposalStatus(
    status: ProposalModel.Status,
    suffixIconRes: String? = null,
    modifier: Modifier = Modifier,
    style: ProposalStatusStyle = ProposalStatusStyle.Default,
) {
    val esColorScheme = MaterialTheme.esColorScheme
    val color = remember(status) {
        when (status) {
            ProposalModel.Status.Todo -> esColorScheme.bgDisable
            ProposalModel.Status.InProgress -> Orange900
            ProposalModel.Status.Sent -> esColorScheme.tintedPressed
            ProposalModel.Status.Confirmed -> Green200
            ProposalModel.Status.ItineraryReady -> Accent200
            ProposalModel.Status.Accepted -> Green600
            ProposalModel.Status.OnHold -> Red50
            ProposalModel.Status.FollowedUp -> Green400
            ProposalModel.Status.NotBooked -> Orange800
        }
    }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(1.spacing),
        modifier = modifier
            .background(color, CircleShape)
            .padding(
                vertical = style.vPadding,
                horizontal = EsConstants.StatusDropdownHorizontalPadding,
            ),
    ) {
        Text(
            text = status.toString(),
            color = if (status == ProposalModel.Status.Accepted)
                Color.White else
                MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.p2Medium14,
        )

        suffixIconRes?.let {
            EsMediumIcon(
                res = it,
                tint = MaterialTheme.esColorScheme.iconPrimary,
            )
        }
    }
}

enum class ProposalStatusStyle {
    Default,
    Large;

    val vPadding: Dp
        get() = when (this) {
            Default -> EsConstants.StatusDropdownVerticalPadding
            Large -> EsConstants.StatusDropdownVerticalPaddingLarge
        }

}